import { FORMS_OPTIN_PARAM, FORMS_OPTIN_VALUE, isFormsOptIn } from '~/libs/formsDrupal'

// An opted-in staff test (`?forms=drupal`) keeps its opt-in across client-side navigation between
// /gava pages, so the next form is read the same way. A full page load is the server's call.
export default defineNuxtRouteMiddleware((to, from) => {
  // A link that sets `forms` itself, to any value, keeps it.
  const gava = to.path === '/gava' || to.path.startsWith('/gava/')
  if (!gava || !isFormsOptIn(from.query) || FORMS_OPTIN_PARAM in to.query) return
  return navigateTo(
    {
      path: to.path,
      query: { ...to.query, [FORMS_OPTIN_PARAM]: FORMS_OPTIN_VALUE },
      hash: to.hash,
    },
    { replace: true },
  )
})
